import { defineMessages } from 'react-intl';

export const loyaltyMessages = defineMessages({
    header: {
        id: 'loyaltyMessages.header',
        description: 'Title of points notice section of checkout form',
        defaultMessage: 'Shopper\'s Card'
    },
    signUpLink: {
        id: 'loyaltyMessages.signUpLink',
        description: 'Text for order summary sign up button',
        defaultMessage: 'Sign Up'
    },
    logInLink: {
        id: 'loyaltyMessages.logInLink',
        description: 'Text for order summary log in button',
        defaultMessage: 'Log In'
    },
    notLoggedInLanguageFirstBit: {
        id: 'loyaltyMessages.notLoggedInLanguageFirstBit',
        description: 'Text for loyalty excerpt when not logged in, first bit',
        defaultMessage: "Earn fuel points on every gift card purchase when you " +
            "{signUpLink} or {logInLink} with your {name} account."
    },
    loggedInLanguageFirstBit: {
        id: 'loyaltyMessages.loggedInLanguageFirstBit',
        description: 'Text for loyalty excerpt when logged in, first bit',
        defaultMessage: "Fuel points will be applied to your account."
    },
    eitherStatusLanguageSecondBit: {
        id: 'loyaltyMessages.eitherStatusLanguageSecondBit',
        description: 'Text for loyalty excerpt for either logged in or not, second bit',
        defaultMessage: "Fuel points may take 48-72 hours to be applied to your " +
            "<strong>Kroger Family of Stores</strong> loyalty account."
    },
});
